import {
  TConvertedCoefficientsTypeReport,
  TSearchMultiInputOptionsArray,
} from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';

// функция применения фильтра для складов и ее сортировка
export const getFormattedFilteredCoefficientsReport = (
  filter: TSearchMultiInputOptionsArray,
  coefficientsReport?: TConvertedCoefficientsTypeReport,
): TConvertedCoefficientsTypeReport => {
  if (!filter.length || !coefficientsReport) {
    return null;
  }
  const selectedIds = filter.map((el) => el.value);

  return Object.entries(coefficientsReport).reduce((acc, [key, value]) => {
    if (
      selectedIds.includes(value[Object.keys(value)[0]][0].warehouseID) ||
      selectedIds.includes(-1)
    ) {
      acc[key] = Object.entries(value).reduce(
        (itemAcc, [itemKey, itemValue]) => {
          // eslint-disable-next-line no-param-reassign
          itemAcc[itemKey] = itemValue.sort(
            (firstEl, secondEl) =>
              new Date(firstEl.date).getTime() -
              new Date(secondEl.date).getTime(),
          );

          return itemAcc;
        },
        {},
      );
    }

    return acc;
  }, {});
};
